import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
export var TOOL_TYPES = {
    TOOL: 'tool',
    GUIDE: 'guide',
    DISCOVERY: 'discovery',
    SOLUTION_SESSION: 'solution-session',
    ASSESSMENT: 'assessment',
};
export var TOOL_TYPE_LABELS = appStrings.modules.toolTypes;
export var getToolTypeLabel = function (toolType) { var _a; return (_a = TOOL_TYPE_LABELS[toolType !== null && toolType !== void 0 ? toolType : 'tool']) !== null && _a !== void 0 ? _a : TOOL_TYPE_LABELS.tool; };
